import { Pipe, PipeTransform } from '@angular/core';
import { Weapon } from '../models/weapon';

@Pipe({
  name: 'weaponCatToWeapon'
})
export class WeaponCatToWeaponPipe implements PipeTransform {

  transform(weapons: Weapon[], weaponCatIdFilter?: number): any[] {
    if (!weapons || !weaponCatIdFilter) {
      return weapons;
    }
    return weapons.filter(a => a.primaryWeaponUID === weaponCatIdFilter);
  }

}
